// import React, { useEffect, useState } from "react";
// import logo from "../assetsWeb/images/logo-white.png";
// import footerlogo from "../assetsWeb/images/logo-color.png";
// import pic1 from "../assetsWeb/images/header-img.png";
// import { CiLocationArrow1, CiLocationOn } from "react-icons/ci";
// import food from "../assetsWeb/images/categ-1.png";
// import fipackage from "../assetsWeb/images/categ-2.png";
// import fipharmacy from "../assetsWeb/images/categ-3.png";
// import shops from "../assetsWeb/images/categ-4.png";
// import groceries from "../assetsWeb/images/categ-5.png";
// import bargain from "../assetsWeb/images/categ-6.png";

// import googlee from "../assetsWeb/images/androidstore.png";
// import applee from "../assetsWeb/images/appstore.png";
// import food1 from "../assetsWeb/images/food.png";
// import cart from "../assetsWeb/images/cart.png";
// import medicine from "../assetsWeb/images/medicine.png";
// import shop from "../assetsWeb/images/shop.png";

// import pic2 from "../assetsWeb/images/prod-1.png";
// import pic3 from "../assetsWeb/images/prod-2.png";
// import pic4 from "../assetsWeb/images/prod-3.png";
// import pic5 from "../assetsWeb/images/prod-4.png";

// import d111 from "../assetsWeb/images/d111.png";
// import d112 from "../assetsWeb/images/d112.png";
// import d113 from "../assetsWeb/images/d113.png";
// import d114 from "../assetsWeb/images/d114.png";
// import d115 from "../assetsWeb/images/d115.png";
// import d116 from "../assetsWeb/images/d116.png";

// import e111 from "../assetsWeb/images/energetic-3d-rendered-cartoon-courier-delivering-packages-bike-against-vibrant-blue-background 1.png";
// import e112 from "../assetsWeb/images/partner.png";
// import e113 from "../assetsWeb/images/job-search-recruiting-hiring-concept-doodle-vector-illustration-realistic-3d-object-cartoon-style.png";
// import { Link } from "react-router-dom";
// import { FaRegCircleUser } from "react-icons/fa6";
// import { useDispatch, useSelector } from "react-redux";
// import { setAddress } from "../actions/orderActions";
// import SearchedByMap from "../components/SearchedByMap";
// import { groupSubCategories } from "../actions/subCategories";

// const categories = [
//   {
//     name: "Food",
//     img: food1,
//     link: "/food",
//   },
//   {
//     name: "Pharmacy & Beauty",
//     img: medicine,
//   },
//   {
//     name: "Shops",
//     img: shop,
//   },
//   {
//     name: "Groceries",
//     img: cart,
//   },
// ];
// const HomePageNew = () => {
//   const [values, setValues] = useState({
//     address: "",
//   });
//   const dispatch = useDispatch();

//   const addressSave = (address) => {
//     dispatch(setAddress(address));
//   };
//   useEffect(() => {
//     if (values?.address) {
//       addressSave(values?.address);
//     }
//   }, [values?.address]);
//   const subCategories = useSelector((state) => state.subCategories);
//   const subCategoriesData = async (e) => {
//     dispatch(groupSubCategories());
//   };
//   useEffect(() => {
//     subCategoriesData();
//   }, []);
//   // console.log(subCategories, "subCategories");

//   // let same = [];
//   // let first = ["aba", "bac", "xyz", "aba"];
//   // let sec = ["aba", "bac", "ccc"];
//   // for (same; first + sec; same++) {
//   //   console.log(same);
//   // }

//   return (
//     <>
//       <div className="bitefooflyheader-section ">
//         <div className="container-fluid mb-3">
//           <div className="row">
//             <div className="riawiza-header-img">
//               <nav className="navbar navbar-expand-lg navbar-light bg-light-subtle ">
//                 <div className="container">
//                   {/* <!-- Logo --> */}
//                   <Link className="navbar-brand" to="/">
//                     <img
//                       src={logo}
//                       alt="Logo"
//                       id="logsedf"
//                       style={{ width: "52%" }}
//                     />
//                   </Link>
//                   {/* <!-- Toggle button for small screens --> */}
//                   <button
//                     className="navbar-toggler"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#navbarSupportedContent"
//                     aria-controls="navbarSupportedContent"
//                     aria-expanded="false"
//                     aria-label="Toggle navigation"
//                   >
//                     <span className="navbar-toggler-icon"></span>
//                   </button>
//                   {/* <!-- Navbar links --> */}
//                   <div
//                     className="collapse navbar-collapse justify-content-end"
//                     id="navbarSupportedContent"
//                   >
//                     <ul className="navbar-nav">
//                       <li className="nav-item">
//                         {/* <Link
//                           to="/all"
//                           role="button"
//                           className="button-21"
//                           style={{ marginRight: "20px", color: "#000" }}
//                         >
//                           <span className="icon-user">
//                             <i
//                               className="fa-solid fa-cart-shopping"
//                               title="Show cart"
//                             ></i>
//                           </span>{" "}
//                         </Link>
//                         <Link
//                           to="/"
//                           role="button"
//                           className="button-21"
//                           style={{ marginRight: "20px", color: "#000" }}
//                         >
//                           <span className="icon-user">
//                             <i
//                               className="fa-solid fa-bag-shopping"
//                               title="Checkout"
//                             ></i>{" "}
//                           </span>{" "}
//                         </Link> */}
//                         <Link
//                           to="/login"
//                           className="button-21"
//                           role="button"
//                           style={{ marginRight: "45px", color: "#28B8EC" }}
//                         >
//                           <span className="icon-user">
//                             <FaRegCircleUser />
//                           </span>{" "}
//                           &nbsp;Login
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </nav>
//             </div>
//           </div>
//         </div>
//         <div className="container" style={{ height: "80vh" }}>
//           <div className="row align-items-center">
//             <div className="col-lg-6 col-md-4 col-sm-12">
//               <div className="text-center">
//                 <img
//                   // src="assets/images/header-img.png"
//                   src={pic1}
//                   alt=""
//                   className="w-50"
//                 />
//               </div>
//             </div>
//             <div className="col-lg-6 col-md-8 col-sm-12">
//               <div className="bitefooflyheader-text">
//                 <h2>One Solution for Every Delivery!</h2>
//                 <div className="bitefooflyheader-search">
//                   <div className="custom-input-group">
//                     <SearchedByMap
//                       values={values}
//                       setValues={setValues}
//                       homePage={true}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div class="curve-svg"></div>
//       </div>
//       <div className="categ-section">
//         <section className="py-5 bg-white text-center">
//           <div className="container">
//             <div className="row justify-content-center">
//               {categories.map((cat, idx) => (
//                 <div className="col-6 col-md-3 mb-4" key={idx}>
//                   <Link
//                     to={cat.link || "#"}
//                     style={{ textDecoration: "none", color: "inherit" }}
//                   >
//                     <div className="category-icon mb-2 mx-auto">
//                       <img src={cat.img} alt={cat.name} />
//                     </div>
//                     <p className="fw-semibold text-dark">{cat.name}</p>
//                   </Link>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//       </div>
//       <div className="store-section">
//         <div className="store-section">
//           <h1>Shops You Might Like</h1>
//           <br />
//           <div className="store-grid">
//             <div className="store">
//               <img src={pic2} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>KFCC</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic3} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Chicken Inn</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic4} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Galito's</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic5} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Drovi Bargains</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic2} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>KFCC</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic3} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Chicken Inn</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic4} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Galito's</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//             <div className="store">
//               <img src={pic5} alt="Store Image" />
//               <div style={{ display: "flex", justifyContent: "space-between" }}>
//                 <h3 style={{ color: "#00A699" }}>Drovi Bargains</h3>
//                 <div style={{ alignContent: "center", margin: "10px" }}>
//                   96%(500+)
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="categ-section">
//         <section className="categories-section">
//           <h2>Top Categories in Nairobi</h2>
//           <div className="categories-container">
//             <div className="category-item">
//               <img src={d111} alt="Chicken" />
//               <span className="category-tag">Chicken</span>
//             </div>
//             <div className="category-item">
//               <img src={d112} alt="Burger" />
//               <span className="category-tag">Burger</span>
//             </div>
//             <div className="category-item">
//               <img src={d113} alt="Fast Food" />
//               <span className="category-tag">Fast Food</span>
//             </div>
//             <div className="category-item">
//               <img src={d114} alt="Pizza" />
//               <span className="category-tag">Pizza</span>
//             </div>
//             <div className="category-item">
//               <img src={d115} alt="Desserts" />
//               <span className="category-tag">Desserts</span>
//             </div>
//             <div className="category-item">
//               <img src={d116} alt="Pasta" />
//               <span className="category-tag">Pasta</span>
//             </div>
//           </div>
//         </section>
//       </div>
//       <div className="store-section">
//         <div className="container">
//           <div className="row">
//             <div className="col-md-12 mb-3">
//               <div className="store-heading text-center">
//                 <h2>Let’s do it together</h2>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-6 d-flex">
//               <div className=" flex-fill d-flex flex-column">
//                 <div className="together">
//                   <img src={e111} alt="Become a rider" />
//                 </div>
//                 <div className="card-body text-center d-flex flex-column">
//                   <h5 className="mb-2">Become a rider</h5>
//                   <p>
//                     Enjoy flexibility, freedom and competitive earnings by
//                     delivering through Drovi.
//                   </p>
//                   <div className="mt-auto">
//                     <button className="btn btn-secondary rounded-pill px-5 register1">
//                       Register Here
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-6 d-flex">
//               <div className=" flex-fill d-flex flex-column">
//                 <div className="together">
//                   <img src={e112} alt="Become a rider" />
//                 </div>
//                 <div className="card-body text-center d-flex flex-column">
//                   <h5 className="mb-2">Become a partner</h5>
//                   <p>
//                     Grow with Drovi! Our technology and user base can help you
//                     boost sales and unlock new opportunities!
//                   </p>
//                   <div className="mt-auto">
//                     <button className="btn btn-secondary rounded-pill px-5 register1">
//                       Register Here
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-4 col-md-6 d-flex">
//               <div className=" flex-fill d-flex flex-column">
//                 <div className="together">
//                   <img src={e113} alt="Become a rider" />
//                 </div>
//                 <div className="card-body text-center d-flex flex-column">
//                   <h5 className="mb-2">Careers</h5>
//                   <p>
//                     Ready for an exciting new challenge? If you’re ambitious,
//                     humble, and love working with others, then we want to hear
//                     from you!
//                   </p>
//                   <div className="mt-auto">
//                     <button className="btn btn-secondary rounded-pill px-5 register1">
//                       Register Here
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* <div class="curve-wrapper">
//         <svg viewBox="0 0 1440 100" class="top-curve">
//           <path
//             d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
//             fill="#000"
//           />
//         </svg>
//       </div> */}
//       <div className="footer-section">
//         <div
//           class="curve-wrapper"
//           style={{
//             backgroundColor: "#dff4fc",
//           }}
//         >
//           <svg viewBox="0 0 1440 100" class="top-curve">
//             <path
//               d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
//               fill="#000"
//             />
//           </svg>
//         </div>
//         {/* <div className="footer-arch-top"></div> */}
//         <footer>
//           <h3
//             style={{
//               display: "flex",
//             }}
//           >
//             <a className="navbar-brand" href="#">
//               <img
//                 src={footerlogo}
//                 alt="Logo"
//                 id="logsedf"
//                 style={{ width: "52%" }}
//               />
//             </a>
//           </h3>
//           <div className="footer-container">
//             <div className="footer-column">
//               {/* <h3>Let’s do it together</h3> */}
//               <ul>
//                 <li>
//                   <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
//                     Let’s do it together
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#">Career</a>
//                 </li>
//                 <li>
//                   <a href="#">Partner</a>
//                 </li>
//                 <li>
//                   <a href="#">Couriers</a>
//                 </li>
//                 <li>
//                   <a href="#">Business</a>
//                 </li>
//               </ul>
//             </div>
//             <div className="footer-column">
//               <ul>
//                 <li>
//                   <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
//                     Link of Interest
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#">About Us</a>
//                 </li>
//                 <li>
//                   <a href="#">FAQs</a>
//                 </li>
//                 <li>
//                   <a href="#">Drovi Prime</a>
//                 </li>
//                 <li>
//                   <a href="#">Blog</a>
//                 </li>
//                 <li>
//                   <a href="#">Contact Us</a>
//                 </li>
//                 <li>
//                   <a href="#">Security</a>
//                 </li>
//               </ul>
//             </div>
//             <div className="footer-column">
//               <ul>
//                 <li>
//                   <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
//                     Follow us
//                   </a>
//                 </li>
//                 <li>
//                   <a href="#">Facebook</a>
//                 </li>
//                 <li>
//                   <a href="#">Twitter</a>
//                 </li>
//                 <li>
//                   <a href="#">Instagram</a>
//                 </li>
//               </ul>
//             </div>
//             <div className="footer-column">
//               <div className="app-icons">
//                 <ul>
//                   <li>
//                     <a href="#">
//                       <img src={googlee} alt="Google Play" />
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">
//                       <img src={applee} alt="App Store" />
//                     </a>
//                   </li>
//                   <li>
//                     <a href="#">Terms & Conditions</a>
//                   </li>
//                   <li>
//                     <a href="#">Privacy Policy</a>
//                   </li>
//                   <li>
//                     <a href="#">Cookies Policy</a>
//                   </li>
//                   <li>
//                     <a href="#">Compilance</a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//           <div className="footer-bottom">
//             <p>All Rights Reserved. Iconictek Company © 2024</p>
//           </div>
//         </footer>
//       </div>
//     </>
//   );
// };
// export default HomePageNew;

import React, { useEffect, useState } from "react";
import logo from "../assetsWeb/images/logo-white.png";
import footerlogo from "../assetsWeb/images/logo-color.png";
import pic1 from "../assetsWeb/images/header-img.png";
import { CiLocationArrow1, CiLocationOn } from "react-icons/ci";
import food from "../assetsWeb/images/categ-1.png";
import fipackage from "../assetsWeb/images/categ-2.png";
import fipharmacy from "../assetsWeb/images/categ-3.png";
import shops from "../assetsWeb/images/categ-4.png";
import groceries from "../assetsWeb/images/categ-5.png";
import bargain from "../assetsWeb/images/categ-6.png";
import cover from "../assetsWeb/images/cover.png";

import googlee from "../assetsWeb/images/androidstore.png";
import applee from "../assetsWeb/images/appstore.png";
import food1 from "../assetsWeb/images/food.png";
import cart from "../assetsWeb/images/cart.png";
import medicine from "../assetsWeb/images/medicine.png";
import shop from "../assetsWeb/images/shop.png";

import pic2 from "../assetsWeb/images/prod-1.png";
import pic3 from "../assetsWeb/images/prod-2.png";
import pic4 from "../assetsWeb/images/prod-3.png";
import pic5 from "../assetsWeb/images/prod-4.png";

import d111 from "../assetsWeb/images/d111.png";
import d112 from "../assetsWeb/images/d112.png";
import d113 from "../assetsWeb/images/d113.png";
import d114 from "../assetsWeb/images/d114.png";
import d115 from "../assetsWeb/images/d115.png";
import d116 from "../assetsWeb/images/d116.png";

import e111 from "../assetsWeb/images/energetic-3d-rendered-cartoon-courier-delivering-packages-bike-against-vibrant-blue-background 1.png";
import e112 from "../assetsWeb/images/partner.png";
import e113 from "../assetsWeb/images/job-search-recruiting-hiring-concept-doodle-vector-illustration-realistic-3d-object-cartoon-style.png";
import { Link } from "react-router-dom";
import { FaRegCircleUser } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { setAddress } from "../actions/orderActions";
import SearchedByMap from "../components/SearchedByMap";
import { groupSubCategories } from "../actions/subCategories";

const categories = [
  {
    name: "Food",
    img: food1,
    link: "/food",
  },
  {
    name: "Pharmacy & Beauty",
    img: medicine,
  },
  {
    name: "Shops",
    img: shop,
  },
  {
    name: "Groceries",
    img: cart,
  },
];
const HomePageNew = () => {
  const [values, setValues] = useState({
    address: "",
  });
  const dispatch = useDispatch();

  const addressSave = (address) => {
    dispatch(setAddress(address));
  };
  useEffect(() => {
    if (values?.address) {
      addressSave(values?.address);
    }
  }, [values?.address]);
  const subCategories = useSelector((state) => state.subCategories);
  const subCategoriesData = async (e) => {
    dispatch(groupSubCategories());
  };
  useEffect(() => {
    subCategoriesData();
  }, []);

  return (
    <>
      <div className=" ">
        {/* <div className="bitefooflyheader-section "> */}
        <div className="container-fluid ">
          <div className="row" style={{ backgroundColor: "#28b8ec" }}>
            <div className="riawiza-header-img">
              <nav className="navbar navbar-expand-lg navbar-light bg-light-subtle ">
                <div className="container">
                  {/* <!-- Logo --> */}
                  <Link className="navbar-brand" to="/">
                    <img
                      src={logo}
                      alt="Logo"
                      id="logsedf"
                      style={{ width: "52%" }}
                    />
                  </Link>
                  {/* <!-- Toggle button for small screens --> */}
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  {/* <!-- Navbar links --> */}
                  <div
                    className="collapse navbar-collapse justify-content-end"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <Link
                          to="/login"
                          className="button-21"
                          role="button"
                          style={{ marginRight: "45px", color: "#28B8EC" }}
                        >
                          <span className="icon-user">
                            <FaRegCircleUser />
                          </span>{" "}
                          &nbsp;Login
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        {/* <div
          className="homepage-center text-center d-flex flex-column align-items-center justify-content-center"
          style={{
            height: "90vh",
            backgroundImage: `url(${cover})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "#fff",
            position: "relative",
          }}
        >
          <div
            className="overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.45)",
              zIndex: 1,
            }}
          ></div>

          <div
            className="hero-content"
            style={{
              position: "relative",
              zIndex: 2,
              padding: "20px",
              width: "100%",
              maxWidth: "700px",
            }}
          >
            <div className="category-line d-flex justify-content-center align-items-center gap-4 mb-2 flex-wrap">
              {categories.map((cat, idx) => (
                <Link
                  key={idx}
                  to={cat.link || "#"}
                  className="text-decoration-none text-light d-flex flex-column align-items-center"
                >
                  <img
                    src={cat.img}
                    alt={cat.name}
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                    }}
                  />
                  <p className="fw-semibold mt-2 text-white">{cat.name}</p>
                </Link>
              ))}
            </div>

            <div className="search-location w-100 d-flex justify-content-center">
              <div className="" style={{ maxWidth: "500px", width: "100%" }}>
                <SearchedByMap
                  values={values}
                  setValues={setValues}
                  homePage={true}
                />
              </div>
            </div>
          </div>
        </div> */}
        <div
          className="homepage-center text-center d-flex flex-column align-items-center justify-content-center"
          style={{
            position: "relative",
            height: "90vh",
            overflow: "hidden",
            color: "#fff",
          }}
        >
          {/* 🔹 Background video */}
          {/* <video
            autoPlay
            loop
            muted
            playsInline
            className="bg-video"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <source
              src={require("../assetsWeb/images/bannervid.mp4")}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video> */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: `url(${require("../assetsWeb/images/banner1.png")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              zIndex: 0,
            }}
          />

          {/* 🔹 Dark overlay */}
          <div
            className="overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.45)",
              zIndex: 1,
            }}
          ></div>

          {/* 🔹 Foreground content */}
          {/* 🔹 Foreground content */}
          <div
            className="hero-content container"
            style={{
              position: "relative",
              zIndex: 2,
              padding: "20px",
            }}
          >
            <div className="row align-items-center">
              {/* 🔹 LEFT SIDE: Categories + Search */}
              <div className="col-lg-6 col-md-12 text-center text-lg-start mb-4 mb-lg-0">
                <div className="category-line d-flex justify-content-center justify-content-lg-start align-items-center gap-4 mb-4 flex-wrap">
                  {categories.map((cat, idx) => (
                    <Link
                      key={idx}
                      to={cat.link || "#"}
                      className="text-decoration-none text-light d-flex flex-column align-items-center"
                    >
                      <img
                        src={cat.img}
                        alt={cat.name}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "contain",
                        }}
                      />
                      <p className="fw-semibold mt-2">{cat.name}</p>
                    </Link>
                  ))}
                </div>

                <div className="search-location w-100 d-flex justify-content-center justify-content-lg-start">
                  <div style={{ maxWidth: "500px", width: "100%" }}>
                    <SearchedByMap
                      values={values}
                      setValues={setValues}
                      homePage={true}
                    />
                  </div>
                </div>
              </div>

              {/* 🔹 RIGHT SIDE: WebM Video */}
              <div className="col-lg-6 col-md-12 d-flex justify-content-center">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  // style={{
                  //   width: "100%",
                  //   maxWidth: "480px",
                  //   borderRadius: "16px",
                  //   boxShadow: "0 10px 40px rgba(0,0,0,0.4)",
                  // }}
                >
                  <source
                    src={require("../assetsWeb/images/container.webm")}
                    type="video/webm"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="store-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-3">
              <div className="store-heading text-center">
                <h2>Let’s do it together</h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className=" flex-fill d-flex flex-column">
                <div className="together">
                  <img src={e111} alt="Become a rider" />
                </div>
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="mb-2">Become a rider</h5>
                  <p>
                    Enjoy flexibility, freedom and competitive earnings by
                    delivering through Drovi.
                  </p>
                  <div className="mt-auto">
                    <button className="btn btn-secondary rounded-pill px-5 register1">
                      Register Here
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className=" flex-fill d-flex flex-column">
                <div className="together">
                  <img src={e112} alt="Become a rider" />
                </div>
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="mb-2">Become a partner</h5>
                  <p>
                    Grow with Drovi! Our technology and user base can help you
                    boost sales and unlock new opportunities!
                  </p>
                  <div className="mt-auto">
                    <button className="btn btn-secondary rounded-pill px-5 register1">
                      Register Here
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 d-flex">
              <div className=" flex-fill d-flex flex-column">
                <div className="together">
                  <img src={e113} alt="Become a rider" />
                </div>
                <div className="card-body text-center d-flex flex-column">
                  <h5 className="mb-2">Careers</h5>
                  <p>
                    Ready for an exciting new challenge? If you’re ambitious,
                    humble, and love working with others, then we want to hear
                    from you!
                  </p>
                  <div className="mt-auto">
                    <button className="btn btn-secondary rounded-pill px-5 register1">
                      Register Here
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-section">
        <div
          class="curve-wrapper"
          style={{
            backgroundColor: "#dff4fc",
          }}
        >
          <svg viewBox="0 0 1440 100" class="top-curve">
            <path
              d="M0,100 C480,0 960,0 1440,100 L1440,100 L0,100 Z"
              fill="#000"
            />
          </svg>
        </div>
        {/* <div className="footer-arch-top"></div> */}
        <footer>
          <h3
            style={{
              display: "flex",
            }}
          >
            <a className="navbar-brand" href="#">
              <img
                src={footerlogo}
                alt="Logo"
                id="logsedf"
                style={{ width: "52%" }}
              />
            </a>
          </h3>
          <div className="footer-container">
            <div className="footer-column">
              {/* <h3>Let’s do it together</h3> */}
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Let’s do it together
                  </a>
                </li>
                <li>
                  <a href="#">Career</a>
                </li>
                <li>
                  <a href="#">Partner</a>
                </li>
                <li>
                  <a href="#">Couriers</a>
                </li>
                <li>
                  <a href="#">Business</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Link of Interest
                  </a>
                </li>
                <li>
                  <a href="#">About Us</a>
                </li>
                <li>
                  <a href="#">FAQs</a>
                </li>
                <li>
                  <a href="#">Drovi Prime</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
                <li>
                  <a href="#">Security</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Follow us
                  </a>
                </li>
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Twitter</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="app-icons">
                <ul>
                  <li>
                    <a href="#">
                      <img src={googlee} alt="Google Play" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={applee} alt="App Store" />
                    </a>
                  </li>
                  <li>
                    <a href="#">Terms & Conditions</a>
                  </li>
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Cookies Policy</a>
                  </li>
                  <li>
                    <a href="#">Compilance</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>All Rights Reserved. Iconictek Company © 2024</p>
          </div>
        </footer>
      </div>
    </>
  );
};
export default HomePageNew;
